import {
  UPDATE_TABLE,
  RESIZE_TABLE,
  COLAPSE_DASH,
  GET_COLLECTION_TABLE,
  CLOSE_TAB,
  SET_ACTIVE_TAB,
  REPLACE_TAB, ADD_SELECT_ITEMS
} from "../constans";
import {
  getSchedule,
  tableSelect,
  resizeViewer, getCollectionTable,
} from "../../utils/builder/IScheduleLogic";
import { logError } from "../../utils/builder/IAmecLog";

export const updateTable = (properties, groups) => async (dispatch) => {
  try {
    const res = await getSchedule(properties, groups);

    dispatch({
      type: UPDATE_TABLE,
      payload: {...res, properties, groups}
    });
  } catch (err) {
    logError("FrontEnd.src.store.actions.table.updateTable", err.toString());
  }
};
export const ElementsAction = (elements) => async (dispatch) => {
  try {
    await tableSelect(elements);
  } catch (err) {
    logError("FrontEnd.src.store.actions.table.ElementsAction", err.toString());
  }
};

export const resizeTable = () => {
  const width = document.getElementById("sidebar").offsetWidth;

  resizeViewer();

  return {
    type: RESIZE_TABLE,
    payload: width,
  };
};

export const colaplseDashboard = (element) => async (dispatch) => {
  await dispatch({
    type: COLAPSE_DASH,
    payload: element,
  });

  resizeViewer();
};

export const getTableCollection = (res) => async (dispatch) => {
  const tableCollection = await getCollectionTable(res.collection);

  await dispatch({
    type: GET_COLLECTION_TABLE,
    payload: { tableCollection, collection: res.collection, folder: res.folder},
  });
};

export const closeTab = (tab) => {

  return {
    type: CLOSE_TAB,
    payload: tab,
  };
};

export const setTabActive = (tab) => {

  return {
    type: SET_ACTIVE_TAB,
    payload: tab,
  };
};

export const replaceTab = (res) => {

  return {
    type: REPLACE_TAB,
    payload: res,
  };
};

export const addSelectItems = (res) => {

  return {
    type: ADD_SELECT_ITEMS,
    payload: res,
  };
};
